import { cn } from 'noddi-ui-common';
import { POLYGON_STYLES } from '../constants';

type Variant = 'selected' | 'other' | 'selectedForAction';

export const ServiceAreaIcon = ({ variant = 'selected', className }: { variant?: Variant; className?: string }) => {
  const style = POLYGON_STYLES[variant];

  return (
    <div
      className={cn('size-4 rounded-sm border border-black', className)}
      style={{ backgroundColor: style.fillColor, opacity: style.fillOpacity }}
    />
  );
};
